import { Guest } from '@/app/system/guest/Guest';
import { Value } from '@/app/system/guest/Value';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';
import { PatronPoolWithGuests } from '@/app/system/guest/PatronPoolWithGuests';
import { GuestAware } from '@/app/system/guest/GuestAware';

export class GuestChain<T> implements GuestAware<T> {
  private theChain: Value<Record<string, any>>
  private keysKnown: Record<string, number> = {};
  private keysFilled: Record<string, number> = {};
  private filledChainPool = new PatronPoolWithGuests(this);

  public constructor(keysKnown: string[] = []) {
    this.theChain = new Value<Record<string, any>>({}, this);
    if (Array.isArray(keysKnown)) {
      keysKnown.forEach(key => {
        this.keysKnown[key] = 1;
      });
    }
  }

  public receiving(guest: Guest<T>) {
    this.result(guest);
    return this;
  }

  public result(guest: Guest<T>) {
    if (this.isChainFilled()) {
      this.filledChainPool.add(guest);
      this.theChain.receiving(new GuestDynamic(chain => {
        this.filledChainPool.receive(chain);
      }));
    } else {
      this.filledChainPool.add(guest);
    }
    return this;
  }

  public receiveKey(key: string): Guest<unknown> {
    this.keysKnown[key] = 1;
    return new GuestDynamic(value => {
      queueMicrotask(() => {
        this.theChain.receiving(new GuestDynamic(chain => {
          this.keysFilled[key] = 1;
          const lastChain = {
            ...chain,
            [key]: value,
          };
          this.theChain.receive(lastChain);
          if (this.isChainFilled()) {
            this.filledChainPool.receive(lastChain);
          }
        }));
      });
    });
  }

  private isChainFilled() {
    return Object.values(this.keysFilled).length > 0 && Object.values(this.keysFilled).length === Object.values(this.keysKnown).length;
  }
}
